module.exports = __webpack_public_path__ + "static/_macewanLogo-9e4a4e7dc37a81889c47bf20185b0f7c.png";